$(document).on('click', '[data-accordion-title]', function (event) {
  event.preventDefault();
  const $container = $(this).closest('[data-accordions-container]');

  if ($container.data('accordions-mobile-only') == "1" && $(window).outerWidth() > 989 ) {
    return false;
  }

  const $currentBtn = $(this);
  const $currentContent = $(this).siblings('[data-subaccordion]');
  $currentBtn.toggleClass('is-open');
  $currentContent.slideToggle();
  $('[data-accordion-title]', $container).not($currentBtn).removeClass('is-open');
  $('[data-subaccordion]', $container).not($currentContent).slideUp();
});

$(document).on('click', '[data-accordion-subtitle]', function (event) {
  event.preventDefault();
  const $container = $(this).closest('[data-accordions-container]');

  if ($container.data('accordions-mobile-only') == "1" && $(window).outerWidth() > 989 ) {
    return false;
  }

  const $currentBtn = $(this);
  const $currentContent = $(this).siblings('[data-accordion-content]');
  const $currentItem = $(this).closest('[data-subaccordion]');
  $currentBtn.toggleClass('is-open');
  $currentContent.slideToggle();
  $currentItem.toggleClass('faq-open_background');
  $('[data-accordion-subtitle]', $container).not($currentBtn).removeClass('is-open');
  $('[data-accordion-content]', $container).not($currentContent).slideUp();
  $('[data-subaccordion]', $container).not($currentItem).removeClass('faq-open_background');
});

$(document).ready(function(){
  $('.sf__pcard-content .box').matchHeight({
   byRow: true,
   });
});


// custom- description
$(document).ready(function() {
  $(".product-form .main-product__block .desc_wrapper .read_more").on("click", function() {
    let wrapper = $(this).closest('.desc_wrapper');
    wrapper.find('.desc1').fadeOut(200, function() {
      wrapper.find('.desc2').fadeIn(200);
    });
  });

  $(".product-form .main-product__block .desc_wrapper .read_less").on("click", function() {
    let wrapper = $(this).closest('.desc_wrapper');
    wrapper.find('.desc2').fadeOut(200, function() {
      wrapper.find('.desc1').fadeIn(200);
    });
  });
});


document.addEventListener("cart:updated", function (event) {
document.querySelectorAll("product-recommendations").forEach(r => r.refresh());

});


/************************CODE TO HANDLE PRICE OF SUBSCRIPTIONS WRAPPER ***********************/

document.addEventListener("DOMContentLoaded", function () {


  console.log("DOM fully loaded");

  /* ---------------- PARSE PRICE ---------------- */
  function parsePrice(priceStr){
    const number = parseFloat(priceStr.replace(/[^0-9.]/g, ""));
    return number;
  }
  /* ---------------- FORMAT PRICE ---------------- */
  function formatPrice(number){
    return "$" + number.toFixed(2);
  }
  /* ---------------- CORE PRICE ENGINE ---------------- */
  function updatePriceUsingVariant(variantEl){

    if(!variantEl){
      console.log("No variant element passed");
      return;
    }

    const priceStr = variantEl.dataset.price;
    if(!priceStr){
      console.log("Variant has no data-price");
      return;
    }

    console.log("Selected variant price:", priceStr);
    const basePrice = parsePrice(priceStr);


   console.log("sdjkvgkjusdgvjlsdjgvldjsg============",basePrice);


    const activePlan = document.querySelector(".plan-card.active");
    if(!activePlan){
      console.log("No active plan-card");
      return;
    }

    const target = activePlan.dataset.target;
    console.log("Active plan target:", target);

    let finalPrice = basePrice;
const dropdowns = document.querySelector('.delivery-dropdown');
const selectedOptions = dropdowns.options[dropdowns.selectedIndex];
const $sellingPlanInput = $('input[name="selling_plan"]');
    if(target === "subscribe"){
      finalPrice = basePrice * 0.9;
      console.log("10% discount applied:", finalPrice);
     if ($sellingPlanInput.length) {
    $sellingPlanInput.val(selectedOptions.value).trigger('change');
    }

    } else {

   if ($sellingPlanInput.length) {
    $sellingPlanInput.val('').trigger('change');
    }

    }

    const formatted = formatPrice(finalPrice);
    console.log("Final price:", formatted);

    /* ---- Update global prices ---- */
    document.querySelectorAll(".new_var_price, .prod__price")
      .forEach(el=> el.textContent = formatted);

    /* ---- Update active plan card prices ---- */
    const oneTimeEl = activePlan.querySelector(".one-time-price");
    const currentEl = activePlan.querySelector(".current");
    const subEl = activePlan.querySelector(".sub-price");
    const oldEl = activePlan.querySelector(".old");

   
    if(oneTimeEl) oneTimeEl.textContent = formatted;
    if(currentEl) currentEl.textContent = formatted;
    if(subEl) subEl.textContent = formatted;
    if(oldEl) oldEl.textContent = formatPrice(basePrice);
    
  }




  // /* ---------------- VARIANT CLICK ---------------- */
  // document.querySelectorAll(".variant-picker__option").forEach(option=>{
  //   option.addEventListener("click", function(){

  //     const input = this.querySelector("input");
  //     if(!input) return;

  //     const group = input.name;

  //     document.querySelectorAll(`.variant-picker__option input[name="${group}"]`)
  //     .forEach(i=>{
  //       i.closest(".variant-picker__option").classList.remove("selected");
  //     });

  //     this.classList.add("selected");

  //     console.log("Variant clicked:", this.dataset.value);

  //     // updatePriceUsingVariant(this);
  //   });
  // });

  document.querySelectorAll(".variant-picker__option").forEach(option => {

  option.addEventListener("click", function(){

    /* ✅ CHECK OPTION NAME FIRST */
    const optionName = this.closest('[data-option-name]')?.dataset.optionName;

    const skipNames = ["About Bristles", "Bristle type" , "Hand Type"];

    if (skipNames.includes(optionName)) {
      console.log("Skipped variant logic for:", optionName);
      return; // 🚫 stop everything
    }

    const input = this.querySelector("input");
    if(!input) return;

    const group = input.name;

    document.querySelectorAll(`.variant-picker__option input[name="${group}"]`)
      .forEach(i => {
        i.closest(".variant-picker__option").classList.remove("selected");
      });

    this.classList.add("selected");

    console.log("Variant clicked:", this.dataset.value);

    // updatePriceUsingVariant(this);

  });

});

  /* ---------------- PLAN CLICK ---------------- */
  document.addEventListener("click", function(e){

    const card = e.target.closest(".plan-card");
    if(!card) return;

    console.log("Plan clicked");

    /* wait until theme switches active class */
    setTimeout(()=>{

      const selectedVariant = document.querySelector(".variant-picker__option.selected");

      if(!selectedVariant){
        console.log("No selected variant found");
        return;
      }

      console.log("Updating price after plan change");

      updatePriceUsingVariant(selectedVariant);

    }, 10);

  });

  /* ---------------- INITIAL LOAD ---------------- */
  const preselected = document.querySelector(".variant-picker__option.selected");

  if(preselected){
    console.log("Initial load price sync");
    updatePriceUsingVariant(preselected);
  }









function updateSellingPlan($dropdown) {
  const selectedOption = $dropdown.find('option:selected');
  const indexx = selectedOption.attr('index');
  const values = selectedOption.val();
  const $sellingPlanInput = $('input[name="selling_plan"]');

  if ($sellingPlanInput.length) {
    $sellingPlanInput.val(values).trigger('change');
  }
}

// On change
$('.delivery-dropdown').on('change', function () {
  updateSellingPlan($(this));
});









});



/*******************CODE TO UPDATE THE PRICE IN STICKY CART WHEN CLICK ON SUBSCRIPTIONS CARD */

document.addEventListener("click", function(e){

  const card = e.target.closest(".plan-card");
  if(!card) return; // click was not inside plan-card
  console.log("Plan card clicked");
  // wait in case theme switches active class after click
  setTimeout(()=>{

    const activeCard = document.querySelector(".plan-card.active");
    if(!activeCard){
      console.log("No active plan-card found");
      return;
    }

    console.log("Active plan:", activeCard);

    const currentPriceEl = activeCard.querySelector(".current");
    if(!currentPriceEl){
      console.log("No .current element inside active plan");
      return;
    }
    const priceText = currentPriceEl.textContent.trim();
    console.log("Active plan price:", priceText);

    document.querySelectorAll(".prod__sticky-atc .new_var_price")
      .forEach(el=>{
        el.textContent = priceText;
      });
  }, 120); // small delay ensures active class updated
});



/***********************CODE TO UPDATE THE SELECTED VARIANT TITLE IN STICKY CART *************************/

document.addEventListener("DOMContentLoaded", function () {

  function updateStickyText() {
    const els = document.querySelectorAll(".selected-value.option-label");

    const first  = els[0]?.textContent.trim() || "";
    const second = els[1]?.textContent.trim() || "";
    const third  = els[2]?.textContent.trim() || "";

    const sticky = document.querySelector(".sticky-variant-text.mr-5");
    if (!sticky) return;

    // Combine only existing values
    const combined = [first, second, third].filter(Boolean).join(" / ");
    sticky.textContent = combined;
  }

  // Run on load
  updateStickyText();

  // Run when variant option clicked
  document.addEventListener("click", function(e){
    if (e.target.closest(".variant-picker__option")) {
      // wait for Shopify/theme to update selected labels first
      setTimeout(updateStickyText, 50);
    }
  });

});






// document.querySelectorAll(".variant-picker__option").forEach(option => {
//   option.addEventListener("click", function () {

//     // Remove active class (optional)
//     document.querySelectorAll(".variant-picker__option")
//       .forEach(opt => opt.classList.remove("active"));

//     this.classList.add("active");

//     // Get numeric price
//     const price = parseFloat(this.dataset.price);
//     if (isNaN(price)) return;

//     // Format original price
//     const formattedPrice = `$${price.toFixed(2)}`;

//     // Calculate 10% discount
//     const discountedPrice = price * 0.9;
//     const formattedDiscounted = `$${discountedPrice.toFixed(2)}`;

//     // Update normal price elements
//     document.querySelectorAll(".one-time-price, .plan-price .current")
//       .forEach(el => el.textContent = formattedPrice);

//     // Update discounted price elements
//     document.querySelectorAll(".sub-price, .price-wrap-sub .current")
//       .forEach(el => el.textContent = formattedDiscounted);

//     // Update old price (original before discount)
//     document.querySelectorAll(".price-wrap-sub .old")
//       .forEach(el => el.textContent = formattedPrice);

//   });
// });

document.querySelectorAll(".variant-picker__option").forEach(option => {
  option.addEventListener("click", function () {

    /* ✅ CHECK OPTION NAME FIRST */
    const optionName = this.closest('[data-option-name]')?.dataset.optionName;

    const skipNames = ["About Bristles", "Bristle type" , "Hand Type"];

    if (skipNames.includes(optionName)) {
      console.log("Skipped price update for:", optionName);
      return; // 🚫 stop everything
    }

    // Remove active class (optional)
    document.querySelectorAll(".variant-picker__option")
      .forEach(opt => opt.classList.remove("active"));

    this.classList.add("active");

    // Get numeric price
    const price = parseFloat(this.dataset.price);
    if (isNaN(price)) return;

    // Format original price
    const formattedPrice = `$${price.toFixed(2)}`;

    // Calculate 10% discount
    const discountedPrice = price * 0.9;
    const formattedDiscounted = `$${discountedPrice.toFixed(2)}`;

    // Update normal price elements
    document.querySelectorAll(".one-time-price, .plan-price .current")
      .forEach(el => el.textContent = formattedPrice);

    // Update discounted price elements
    document.querySelectorAll(".sub-price, .price-wrap-sub .current")
      .forEach(el => el.textContent = formattedDiscounted);

    // Update old price (original before discount)
    document.querySelectorAll(".price-wrap-sub .old")
      .forEach(el => el.textContent = formattedPrice);

  });
});


/****************************CODE TO UPDATE THE PRICE BASED ON QUANTITY *********************/
document.addEventListener("DOMContentLoaded", function () {

  /* ---------------- HELPERS ---------------- */

  function parsePrice(str){
    return parseFloat(str.replace(/[^0-9.]/g,'')) || 0;
  }

  function formatPrice(num){
    return "$" + num.toFixed(2);
  }

  function getQuantity(){
    const q = document.querySelector('[data-quantity-input]');
    return q ? parseInt(q.value) || 1 : 1;
  }

  function getSelectedVariant(){
    return document.querySelector(".variant-picker__option.selected, .variant-picker__option.active");
  }

  function isSubscriptionActive(){
    const active = document.querySelector(".plan-card.active");
    return active && active.dataset.target === "subscribe";
  }

  /* ---------------- MAIN PRICE ENGINE ---------------- */

  function updateAllPrices(){

  const variant = getSelectedVariant();
  if(!variant) return;

  const basePrice = parseFloat(variant.dataset.price);
  if(!basePrice) return;

  const qty = getQuantity();

  const subscribeActive = isSubscriptionActive();

  const normalTotal = basePrice * qty;
  const discountTotal = basePrice * 0.9 * qty;

  const formattedNormal = formatPrice(normalTotal);
  const formattedDiscount = formatPrice(discountTotal);

  /* ---------- MAIN PRODUCT PRICE ---------- */

  document.querySelectorAll(".new_var_price, .prod__price")
    .forEach(el => {
      el.textContent = subscribeActive ? formattedDiscount : formattedNormal;
    });

  /* ---------- ONE TIME PRICE ---------- */

  document.querySelectorAll(".one-time-price, .plan-price .current")
    .forEach(el => el.textContent = formattedNormal);

  /* ---------- SUBSCRIPTION PRICE CARD (ALWAYS DISCOUNT) ---------- */

  document.querySelectorAll(".price-wrap-sub").forEach(wrapper => {

    const current = wrapper.querySelector(".current");
    const old = wrapper.querySelector(".old");

    if(current) current.textContent = formattedDiscount;
    if(old) old.textContent = formattedNormal;

  });

  /* ---------- STICKY CART ---------- */

  document.querySelectorAll(".prod__sticky-atc .new_var_price")
    .forEach(el => {
      el.textContent = subscribeActive ? formattedDiscount : formattedNormal;
    });

}

  /* ---------------- VARIANT CLICK ---------------- */

  // document.querySelectorAll(".variant-picker__option").forEach(option => {

  //   option.addEventListener("click", function(){

  //     const input = this.querySelector("input");
  //     if(!input) return;

  //     const group = input.name;

  //     document.querySelectorAll(`.variant-picker__option input[name="${group}"]`)
  //       .forEach(i => i.closest(".variant-picker__option").classList.remove("selected"));

  //     this.classList.add("selected");

  //     setTimeout(updateAllPrices, 50);

  //   });

  // });

  document.querySelectorAll(".variant-picker__option").forEach(option => {

  option.addEventListener("click", function(){

    /* ✅ CHECK OPTION NAME FIRST */
    const optionName = this.closest('[data-option-name]')?.dataset.optionName;

    const skipNames = ["About Bristles", "Bristle type" , "Hand Type"];

    if (skipNames.includes(optionName)) {
      console.log("Skipped updateAllPrices for:", optionName);
      return; // 🚫 stop everything
    }

    const input = this.querySelector("input");
    if(!input) return;

    const group = input.name;

    document.querySelectorAll(`.variant-picker__option input[name="${group}"]`)
      .forEach(i => i.closest(".variant-picker__option").classList.remove("selected"));

    this.classList.add("selected");

    setTimeout(updateAllPrices, 50);

  });

});

  /* ---------------- PLAN CLICK ---------------- */

  document.addEventListener("click", function(e){

    const card = e.target.closest(".plan-card");
    if(!card) return;

    setTimeout(updateAllPrices, 120);

  });

  /* ---------------- QUANTITY CHANGE ---------------- */

  const qtyInput = document.querySelector('[data-quantity-input]');

  if(qtyInput){

    qtyInput.addEventListener("input", updateAllPrices);

    document.querySelectorAll('[data-quantity-selector]')
      .forEach(btn => {
        btn.addEventListener("click", function(){
          setTimeout(updateAllPrices, 60);
        });
      });

  }

  /* ---------------- STICKY VARIANT TEXT ---------------- */

  function updateStickyText(){

    const els = document.querySelectorAll(".selected-value.option-label");

    const values = [...els].map(el => el.textContent.trim()).filter(Boolean);

    const sticky = document.querySelector(".sticky-variant-text.mr-5");
    if(!sticky) return;

    sticky.textContent = values.join(" / ");

  }

  document.addEventListener("click", function(e){

    if(e.target.closest(".variant-picker__option")){
      setTimeout(updateStickyText, 50);
    }

  });

  /* ---------------- INITIAL LOAD ---------------- */

  updateAllPrices();
  updateStickyText();

});